module.exports = __webpack_public_path__ + "img/BPPMP11.9a44bb66.png";